'use client'

import type { CSSProperties, MouseEventHandler, ReactNode } from 'react'

import Button from 'react-bootstrap/Button'

interface NormalButtonProps {
  text: ReactNode
  /** Image src rendered before the label. */
  icon?: string
  id?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  style?: CSSProperties
}

function NormalButton({ text, icon, id, onClick, disabled, style }: NormalButtonProps) {
  return (
    <>
      <style type="text/css">
        {`
          .btn-light {
            background: none;
            color: var(--alrajhi-primary);
            padding: 12px 20px;
            font-size: 16px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
            border: 2px solid var(--alrajhi-primary);
          }
          .btn-light:hover {
            transition: 0.5s;
            background: initial;
            color: var(--alrajhi-primary);
            border: 2px solid var(--alrajhi-primary);
            // transform: scale(1.1);
          }
        `}
      </style>

      <Button
        variant="light"
        id={id}
        onClick={onClick}
        disabled={disabled}
        style={{
          ...style,
          background: disabled ? 'grey' : undefined,
          borderWidth: disabled ? 0 : undefined
        }}
      >
        {icon && <img src={icon} width="16" className="pe-1" alt={`${icon}`} />}
        {text}
      </Button>
    </>
  )
}

export default NormalButton
